exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-category[data-v-6af8d2a0]{position:relative;top:-30px;left:175px}.disabled-look[data-v-6af8d2a0]{opacity:.65;cursor:pointer}", ""]);

// exports
